"use client";
import dynamic from "next/dynamic";
import { Suspense } from "react";
const Login = dynamic(() => import("@/views/Login"), { ssr: false });
export default function LoginPage() {
  return <Suspense><Login /></Suspense>;
}
